<ion-header>
  <ion-toolbar>
    <ion-title class="toolbar"> Fermeture définitive </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid fixed>
    <ion-row>
      <ion-col size="12">
        <ion-item>
          <ion-textarea
            [(ngModel)]="commentaire"
            label="Commentaire"
            label-placement="stacked"
            placeholder="Merci d’ajouter un commentaire afin de mieux comprendre et traiter votre demande"
            rows="10"
            autoGrow="true">
          </ion-textarea>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row class="button-row">
      <ion-col size="6">
        <ion-button (click)="annuler()" class="yellow" expand="block">
          <ion-icon name="close-sharp" slot="start"></ion-icon>
          Annuler
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button
          (click)="enregistrer()"
          class="green"
          expand="block"
          [disabled]="!commentaire || commentaire.trim() === ''">
          <ion-icon name="checkmark-sharp" slot="start"></ion-icon>
          Enregistrer
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
